import { render, staticRenderFns } from "./bigSink.vue?vue&type=template&id=5460d176&scoped=true&"
import script from "./bigSink.vue?vue&type=script&lang=js&"
export * from "./bigSink.vue?vue&type=script&lang=js&"
import style0 from "./bigSink.vue?vue&type=style&index=0&id=5460d176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460d176",
  null
  
)

export default component.exports